import axios from 'axios';
import { format, parseISO } from 'date-fns';

import { lenientParse, isNumberCellEmpty, formatChartData, createDateAsUTC } from '../../services/items';

export const findLoad = (items, id) => {
    return items.filter((i) => i.id === Number(id))[0];
};

export const getLoads = async (itemTypes) => {
    const { itemTypeId } = itemTypes.filter((item) => item.description === 'Load')[0];

    const response = await axios.get(`/items/${itemTypeId}/items`);
    return response.data;
};

export const getLoadDefinitions = async (itemId) => {
    const response = await axios.get(`/loads/${itemId}/sub-loads`);
    return response.data;
};

export const createLoadDefinition = async (payload) => {
    const response = await axios.post(`/loads/sub-load`, payload);
    return response.data;
};

export const deleteLoadDefinition = (subloadId) => axios.delete(`/loads/${subloadId}`);

export const deleteLoadItem = (loadId) => axios.delete(`/items/${loadId}`);

export const formatDate = (str) => format(parseISO(str), 'Pp');

export const copyLoad = async (loadId) => {
    const response = await axios.post(`/items/${loadId}/copy`);

    return response.data;
};

export const addItemToPortfolios = (itemId, payload) => axios.post(`/items/${itemId}/portfolios`, payload);

export const editLoad = (payload) => axios.put('/loads/modify-load-sub-loads', payload);

export const getLoadData = async (loadId, payload) => {
    const response = await axios.post(`/loads/${loadId}/load-data`, payload);

    return response.data;
};

export const getLoadForecast = async (loadId, payload) => {
    const response = await axios.post(`/loads/${loadId}/load-forecast`, payload);

    return response.data;
};

export const getLoadModel = async (loadId) => {
    const response = await axios.get(`/loads/${loadId}/load-model`);

    return response.data;
};

export const updateLoadData = (subLoadId, payload) => axios.put(`/loads/${subLoadId}/load-data`, payload);

export const updateLoadForecast = (subLoadId, payload) => axios.put(`/loads/${subLoadId}/load-forecasts`, payload);

export const updateLoadModel = (subLoadId, payload) => axios.put(`/loads/${subLoadId}/load-models`, payload);

export const getLoadDataChart = async (loadId, payload) => {
    const response = await axios.post(`/loads/${loadId}/load-data-sampling`, payload);

    return formatChartData(response.data);
};

export const getLoadForecastChart = async (loadId, payload) => {
    const response = await axios.post(`/loads/${loadId}/load-forecast-sampling`, payload);
    return formatChartData(response.data);
};

export const formatParsedNewLoadData = (data) => {
    return data.map(({ startDate, endDate, updateDateTime, load }) => {
        return {
            startDate: startDate ? createDateAsUTC(lenientParse(startDate)) : null,
            endDate: endDate ? createDateAsUTC(lenientParse(endDate)) : null,
            updateDateTime: updateDateTime ? createDateAsUTC(lenientParse(updateDateTime)) : null,
            load: isNumberCellEmpty(load),
        };
    });
};

export const formatParsedNewLoadForecast = (data, forecastTypes) => {
    return data.map((row) => {
        return {
            startDate: row.startDate ? createDateAsUTC(lenientParse(row.startDate)) : null,
            endDate: row.endDate ? createDateAsUTC(lenientParse(row.endDate)) : null,
            updateDateTime: row.updateDateTime ? createDateAsUTC(lenientParse(row.updateDateTime)) : null,
            forecastTypeId: forecastTypes.find((type) => type.description === row.forecastTypeId).id,
            expectedEnergy: isNumberCellEmpty(row.expectedEnergy),
            expectedPeakDemand: isNumberCellEmpty(row.expectedPeakDemand),
            stdDevOfEnergy: isNumberCellEmpty(row.stdDevOfEnergy),
        };
    });
};

export const formatParsedNewLoadModel = (data) => {
    return data.map((row) => {
        return {
            ...row,
            useFlag: Number(row.useFlag) === 1 ? true : false, // required field
            runOrder: isNumberCellEmpty(row.runOrder),
        };
    });
};

export const createLoadData = (subLoadId, payload) => axios.post(`/loads/${subLoadId}/create-load-data`, payload);

export const createLoadForecasts = (subLoadId, payload) =>
    axios.post(`/loads/${subLoadId}/create-load-forecasts`, payload);

export const createLoadModels = (subLoadId, payload) => axios.post(`/loads/${subLoadId}/create-load-models`, payload);

export const deleteLoadData = (subLoadId, payload) => axios.delete(`/loads/${subLoadId}/load-data`, { data: payload });

export const deleteLoadForecasts = (subLoadId, payload) =>
    axios.delete(`/loads/${subLoadId}/load-forecasts`, { data: payload });

export const deleteLoadModels = (subLoadId, payload) =>
    axios.delete(`/loads/${subLoadId}/load-models`, { data: payload });

export const deleteAllLoadData = (subLoadId) => axios.delete(`/loads/${subLoadId}/delete-all-load-data`);

export const deleteAllLoadForecasts = (subLoadId) => axios.delete(`/loads/${subLoadId}/delete-all-load-forecasts`);

export const deleteAllLoadModels = (subLoadId) => axios.delete(`/loads/${subLoadId}/delete-all-load-models`);
